import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Material modules
import { MatIconModule } from '@angular/material/icon';

// Modules
import { PopoverModule } from '@ngx-popovers/popover';

// Components
import { PreviewComponent } from './components/preview/preview.component';
import { PlaybackActionsComponent } from './components/playback-actions/playback-actions.component';
import { PlaybackProgressBarComponent } from './components/playback-progress-bar/playback-progress-bar.component';
import { PlaybackInOutPointsComponent } from './components/playback-in-out-points/playback-in-out-points.component';
import { AudioLevelsComponent } from './components/audio-levels/audio-levels.component';
import { PreviewCcComponent } from './components/preview-cc/preview-cc.component';
import { PreviewTimecodeComponent } from './components/preview-timecode/preview-timecode.component';
import { TranscodeInOutPointsComponent } from './components/transcode-in-out-points/transcode-in-out-points.component';
import { SrtStatsPopoverComponent } from './components/srt-stats-popover/srt-stats-popover.component';



@NgModule({
  imports: [
    CommonModule,

    // Material
    MatIconModule,

    // Modules
    PopoverModule,
  ],
  declarations: [
    PreviewComponent,
    PlaybackActionsComponent,
    PlaybackProgressBarComponent,
    PlaybackInOutPointsComponent,
    AudioLevelsComponent,
    PreviewCcComponent,
    PreviewTimecodeComponent,
    TranscodeInOutPointsComponent,
    SrtStatsPopoverComponent,
  ],
  exports: [
    PreviewComponent,
    PlaybackActionsComponent,
    PlaybackProgressBarComponent,
    PlaybackInOutPointsComponent,
    AudioLevelsComponent,
    PreviewCcComponent,
    PreviewTimecodeComponent,
    TranscodeInOutPointsComponent,
    SrtStatsPopoverComponent,
  ]
})
export class PreviewModule { }
